import { PayNowErrorSeverity } from '@acorn-portal/shared/src/hooks/use-paynow-details-token';
import { PayNowTokenisedLinkError } from '@acorn-portal/shared/src/components/payNow';
import { PropsWithChildren } from 'react';

const ChangeBankError = ({ children }: PropsWithChildren<Record<string, unknown>>) => {
	return (
		<PayNowTokenisedLinkError
			severity={PayNowErrorSeverity.ERROR}
			message='There is an issue with change of bank details'
		>
			{children}
		</PayNowTokenisedLinkError>
	);
};

export default ChangeBankError;
